import { Guid } from '@ef-carbon/primitive';
export async function linkProcessDirect(link, context, _) {
    const { redirect: redirection, id } = link;
    const redirect = redirection ? new Guid(redirection) : undefined;
    return { id: new Guid(id), redirect, context };
}
export { linkProcessDirect as process, linkProcessDirect as direct };
export default linkProcessDirect;
//# sourceMappingURL=direct.js.map